__turbopack_context__.v({
  "custom_text": "K4acyW_custom_text",
  "customizeBodyActive": "K4acyW_customizeBodyActive",
  "customizeBodyDisabled": "K4acyW_customizeBodyDisabled",
  "customizeBodyInactive": "K4acyW_customizeBodyInactive",
  "text": "K4acyW_text",
});
